import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { useDispatch, useSelector } from 'react-redux'
import useModal from '@/shared/hooks/useModal'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useState } from 'react'
import { selectConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'

const useHistoricAuditLogs = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isAdmin } = useSelector(selectAuthData)
  const { isOpen, close, setIsOpen } = useModal()
  const [logs, setLogs] = useState([])
  const { contactId } = useSelector(selectConfig)
  const { id: contractId } = useRetrieveActiveContractIdAndType()

  const callbackHistoricLogs = (response, statusCode) => {
    if (statusCode === 200 && response && Object.keys(response).length > 0) {
      setLogs(response)
    }
    setIsOpen(true)
  }

  const fetchLogs = () => {
    setLogs([])
    dispatch({
      type: subscriptionFormActionsV2.HISTORIC_LOGS_V2,
      callback: callbackHistoricLogs,
      contactId,
      contractId: parseInt(contractId) > 0 ? contractId : 0,
    })
  }

  return { t, isAdmin, isOpen, close, logs, fetchLogs }
}

export default useHistoricAuditLogs
